import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LOADING_STATES } from 'constants/enums'

interface Filter {
  id: string
  label: string
  type: string
}

interface OptionsData {
  genres: unknown[]
  markets: unknown[]
  packages: unknown[]
  release_types: unknown[]
  versions: unknown[]
  moods: unknown[]
  instruments: unknown[]
}

interface AdditionalFilterSettings {
  explicit: boolean
}

interface OptionsState {
  genres: unknown[]
  markets: unknown[]
  packages: unknown[]
  release_types: unknown[]
  versions: unknown[]
  moods: unknown[]
  instruments: unknown[]
  activeFilters: Filter[]
  additionalFilterSettings: AdditionalFilterSettings
  loading: string
}

const initialState: OptionsState = {
  genres: [],
  markets: [],
  packages: [],
  release_types: [],
  versions: [],
  moods: [],
  instruments: [],
  activeFilters: [],
  additionalFilterSettings: { explicit: false },
  loading: LOADING_STATES.IDLE,
}

const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {
    loading: (state, action: PayloadAction<string>) => {
      state.loading = action.payload
    },
    setOptions: (state, action: PayloadAction<OptionsData>) => {
      const options = action.payload
      state.genres = options.genres
      state.markets = options.markets
      state.packages = options.packages
      state.release_types = options.release_types
      state.versions = options.versions
      state.moods = options.moods
      state.instruments = options.instruments
    },
    toggleFilter: (state, action: PayloadAction<Filter>) => {
      const filter = action.payload
      const exists = state.activeFilters.some(
        (f) => f.id === filter.id && f.type === filter.type
      )
      if (exists) {
        state.activeFilters = state.activeFilters.filter(
          (f) => !(f.id === filter.id && f.type === filter.type)
        )
      } else {
        state.activeFilters.push(filter)
      }
    },
    setFilters: (state, action: PayloadAction<Filter[]>) => {
      state.activeFilters = action.payload
    },
    setAdditionalFilterSettings: (state, action: PayloadAction<AdditionalFilterSettings>) => {
      state.additionalFilterSettings = action.payload
    },
    clearAllFilters: (state) => {
      state.activeFilters = []
      state.additionalFilterSettings = { explicit: false }
    },
  },
})

export const optionsActions = optionsSlice.actions
export const optionsReducer = optionsSlice.reducer
export default optionsActions
